const DROPPED_TAGS = ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta', 'form']

// News are written by admins in a rich text editor; keep the formatting, drop anything active.
export const sanitizeNewsHtml = (html: string): string => {
	const doc = new DOMParser().parseFromString(html ?? '', 'text/html')

	doc.querySelectorAll(DROPPED_TAGS.join(',')).forEach((node) => node.remove())
	doc.body.querySelectorAll('*').forEach((element) => {
		Array.from(element.attributes).forEach(({name, value}) => {
			const isHandler = name.toLowerCase().startsWith('on')
			const isScriptUrl = /^\s*javascript:/i.test(value) && ['href', 'src', 'xlink:href'].includes(name.toLowerCase())
			if (isHandler || isScriptUrl) element.removeAttribute(name)
		})
	})

	return doc.body.innerHTML
}
